var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailinline = function SvgMailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11h-2V4.238l-7.928 7.1L2 4.216V16h10v2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10ZM2.511 2l7.55 6.662L17.502 2H2.511ZM17 19l-3.536-3.536 1.415-1.414L17 16.172l3.536-3.536 1.414 1.414L17 19Z"
  })));
};
export default SvgMailinline;